import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { withRouter, routerShape } from 'react-router';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindActionCreators } from 'redux';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { SearchProbeList } from '@bibliocommons/probes';
import SearchActions from '../actions/SearchActions';

export class SearchProbeContainer extends BcReactComponent {
  componentDidMount() {
    this.getSearchProbes(this.props.location.query);
  }

  componentWillReceiveProps(nextProps) {
    const query = this.props.location.query;
    const nextQuery = nextProps.location.query;

    if ((query.query !== nextQuery.query) || (query.searchType !== nextQuery.searchType)) {
      this.getSearchProbes(nextQuery);
    }
  }

  getSearchProbes(query) {
    this.props.searchActions.getSearchProbes(query.query, query.searchType);
  }

  render () {
    const { probes } = this.props;
    return (
      <div className="cp-search-probes">
        <SearchProbeList probes={probes} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  probes: state.getIn(['search', 'catalogSearch', 'probes'])
});

const mapDispatchToProps = dispatch => ({
  searchActions: bindActionCreators(SearchActions, dispatch)
});

SearchProbeContainer.propTypes = {
  probes: ImmutablePropTypes.map,
  searchType: PropTypes.string,
  getSearchProbes: PropTypes.func.isRequired,
  searchActions: PropTypes.objectOf(PropTypes.func),
  router: routerShape
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SearchProbeContainer));



// WEBPACK FOOTER //
// ./app/containers/SearchProbeContainer.jsx